angular
	.module 'App.Repository'
	.factory 'NotificationRepository', ['BaseRepository', (BaseRepository) ->
		class NotificationRepository extends BaseRepository
			@resource = '/notifications/web'
			@isRestricted = true

		return new NotificationRepository
	]
